import { type } from './shared';

export const deserialize = ({ editor, position, data, ...node }) => {
  return {
    ...node,
    type,
    children: [{ text: '' }],
    align:
      data?.hProperties?.align ||
      (data?.hProperties?.className === 'border' || data?.hProperties?.width ? 'center' : ''),
    alt: node.alt,
    border: data?.hProperties?.className === 'border' || node.border,
    width: data?.hProperties?.width,
    url: node.url || node.src,
  };
};

export const serialize = ({ children, align, alt, border = false, isInline, width, url, ...image }) => {
  if (isInline) {
    return {
      src: url,
      url,
      ...image,
    };
  }

  image.data = {
    hProperties: {
      ...(align && { align }),
      ...(alt && { alt }),
      ...(border && { className: 'border' }),
      ...(border && { border }),
      ...(width && { width }),
    },
  };

  return {
    align,
    alt,
    border,
    width,
    src: url,
    url,
    ...image,
  };
};
